module.exports = __webpack_public_path__ + "static/media/021-night-1.e8b0196c.svg";